import { Grid, Typography } from '@mui/material';

import { ConnectedSelect } from '@libs/ui/components/form/select';
import { ConnectedTextField } from '@libs/ui/components/form/text-field';

import { Question } from './types';

interface QuestionControlProps {
  question: Question;
  name: string;
  endAdornment?: React.ReactNode;
}

export const QuestionControl = ({
  question,
  name,
  endAdornment,
}: QuestionControlProps) => {
  const getLabel = () => (
    <Typography>
      {question.question}
      {question.mandatory && (
        <>
          {' '}
          <Typography component="span" color="error">
            *
          </Typography>
        </>
      )}
    </Typography>
  );

  const renderControl = () => {
    switch (question.type) {
      case 'Open':
        return (
          <ConnectedTextField
            name={name}
            fullWidth
            variant="filled"
            label="Enter your answer"
            {...(endAdornment && {
              InputProps: {
                endAdornment,
              },
            })}
          />
        );

      case 'MultipleChoice':
        return (
          <Grid container width="100%" spacing={2}>
            <Grid item flexGrow={1}>
              <ConnectedSelect
                name={name}
                options={question.possibleAnswers.map((answer) => ({
                  text: answer.answer,
                  value: answer.answer,
                }))}
                {...(question.mandatory && {
                  hideNoneValue: true,
                })}
                fullWidth
                variant="filled"
                label="Select an answer"
                required={question.mandatory}
              />
            </Grid>
            {endAdornment && (
              <Grid item display="flex" alignItems="cneter">
                {endAdornment}
              </Grid>
            )}
          </Grid>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Typography variant="body2" mb={1}>
        {getLabel()}
      </Typography>
      {renderControl()}
    </>
  );
};
